import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.date.now";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import localforage from 'localforage';

var Store = /*#__PURE__*/function () {
  /**
   * @classdesc
   客户端已经添加端内的存储方案，建议使用adapter提供的存储方案。adapter里面的base存储方案是基于localforage封装的，支持异步存储。在端内可以跨页面和跨域名。
  [文档](https://fe.zhuanspirit.com/common/native-adapter-doc/docs/#%E8%B0%83%E8%B5%B7%E5%AD%98%E5%82%A8-setstoreitem)
  离线存储方案。通过类似 `localStorage API` 的异步存储来改进应用程序的离线体验。能存储多种类型的数据，而不仅仅是字符串。
  此方案基于 [localforage](http://localforage.docschina.org/) 封装，采用优雅降级，优先使用 IndexedDB 或 WebSQL，若浏览器不支持，则使用 localStorage。
   * @constructs Store
   * @param {Object} config 配置项
   * @param {String} config.name 业务线或项目名称，如：`platform_book`
   * @param {Number} config.expire 默认过期时间，单位天，不设置则永久储存
   */
  function Store() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Store);

    this.expire = config.expire || 0;

    try {
      this.store = localforage.createInstance(Object.assign({
        name: 'common_store',
        // web sql 不稳定
        driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE]
      }, config));
    } catch (error) {
      console.log(error);
    }
  }
  /**
   * 保存离线数据
   * @method Store#setItem
   * @param {String} key
   * @param {Any} value 支持对象，数组，字符串，数字及二进制文件
   * @param {Number} [expire] 过期时间，单位天。默认取初始化时设置的过期时间
   * @return {Promise} 返回一个 `Promise`，`resolve` 状态的回调参数为 `value`
   */


  _createClass(Store, [{
    key: "setItem",
    value: function setItem(key, value) {
      var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.expire;

      if (expire) {
        expire = Date.now() + expire * 24 * 60 * 60 * 1000;
      }

      return this.store.setItem(key, {
        value: value,
        expire: expire
      }).then(function (res) {
        return res.value;
      });
    }
    /**
     * 获取离线数据
     * @method Store#getItem
     * @param {String} key
     * @return {Promise} 返回一个 `Promise`，`resolve` 状态的回调参数为 `value`
     */

  }, {
    key: "getItem",
    value: function getItem(key) {
      var _this = this;

      return this.store.getItem(key).then(function (res) {
        if (!res) return null;
        var value = res.value,
            expire = res.expire;

        if (expire && expire < Date.now()) {
          return _this.removeItem(key).then(function () {
            return null;
          }); // 返回 null
        }

        return value;
      });
    }
    /**
     * 删除离线数据
     * @method Store#removeItem
     * @param {String} key
     * @return {Promise} 返回一个 `Promise`
     */

  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return this.store.removeItem(key);
    }
    /**
     * 清空当前数据库，请谨慎操作
     * @method Store#clear
     * @return {Promise} 返回一个 `Promise`
     */

  }, {
    key: "clear",
    value: function clear() {
      return this.store.clear();
    }
    /**
     * 清空当前数据库过期数据
     * @method Store#clearExpired
     * @return {Promise} 返回一个 `Promise`
     */

  }, {
    key: "clearExpired",
    value: function () {
      var _clearExpired = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var keys;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.keys();

              case 2:
                keys = _context.sent;
                return _context.abrupt("return", Promise.all(keys.map(function (key) {
                  return new Promise(function (resolve, reject) {
                    _this2.getItem(key).then(resolve)["catch"](reject);
                  });
                })).then(function () {}));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function clearExpired() {
        return _clearExpired.apply(this, arguments);
      }

      return clearExpired;
    }()
    /**
     * 获取当前数据库 `key` 的数量
     * @method Store#length
     * @return {Promise} 返回一个 `Promise`，`resolve` 状态的回调参数为 `length`
     */

  }, {
    key: "length",
    value: function length() {
      return this.store.length();
    }
    /**
     * 获取当前数据库的所有 `key`
     * @method Store#keys
     * @return {Promise} 返回一个 `Promise`，`resolve` 状态的回调参数为包含所有 `key` 的数组
     */

  }, {
    key: "keys",
    value: function keys() {
      return this.store.keys();
    }
  }]);

  return Store;
}();

export { Store as default };